import React from 'react'
import { useTranslation } from 'next-i18next'
import Image from 'next/image'

const ErrorPage = () => {
  const { t } = useTranslation()
  return (
    <div className="place-content-center bg-white px-4 flex items-center h-full">
      <div className="text-center">
        <Image
          src="https://aloebikes.s3.eu-west-3.amazonaws.com/other/500.svg"
          width={250}
          height={250}
          alt="500 error image"
        />

        <h1 className="mt-6 text-2xl font-bold tracking-tight text-gray-900 sm:text-4xl">
          Uh-oh!
        </h1>

        <p className="mt-4 text-gray-500">There&apos;s something wrong</p>
      </div>
    </div>
  )
}

export default ErrorPage
